module.exports = __webpack_public_path__ + "static/img/door--small.5ae5401.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bathroom/door--small.svg
// module id = 143
// module chunks = 2